module.exports = __webpack_public_path__ + "static/media/facebook_white.164d6589.svg";